import React from 'react';
import { useIntl } from 'react-intl';

import { PickListDropdownSetting } from '../../../../../picking/printed-section/printed-section-settings/pick-list-dropdown-setting';

import { packingSlipSortings } from '../../../../../../printing/document-option-modal/packing-slip/constants';
import packingSlipMessages from '../../../../../../printing/document-option-modal/packing-slip/messages';
import { FORM_FIELDS } from '../../constants';

/**
 * @param {{
 *   value: string,
 *   onChange: (field: string, value: string) => void
 * }} props
 * @returns {JSX.Element}
 */
export const PackingSlipOrderItemsBy = ({ value, onChange }) => {
  const intl = useIntl();

  const dropdownItems = packingSlipSortings.map(({ messageDescriptor, value: optionValue }) => ({
    key: optionValue,
    name: intl.formatMessage(messageDescriptor),
  }));

  const handleChange = (selectedValue) => {
    onChange(FORM_FIELDS.PACKING_SLIP_ORDER_ITEMS_BY, selectedValue);
  };

  return (
    <PickListDropdownSetting
      descriptionMessage={packingSlipMessages.orderItemsByDescription}
      items={dropdownItems}
      onChange={handleChange}
      titleMessage={packingSlipMessages.orderItemsByLabel}
      value={value}
    />
  );
};
